import React from 'react'
import PropTypes from 'prop-types'
import { SVGIcon, FormGroup } from 'components/qstrap'
import intl from 'react-intl-universal'
import FacebookLogin from 'react-facebook-login'
import config from 'config'

const FacebookButton = ({ fbName, callback, onClick }) => {
  const text = fbName ? intl.get('account.fb_connected_as', { name: fbName }) : null

  return (
    <FormGroup>
      <FacebookLogin
        appId={config.facebook_app_id}
        fields="name,email"
        scope="public_profile,email"
        callback={callback}
        cssClass="btn-facebook"
        icon={<SVGIcon name="common-facebook" size="sm" className="m-r-sm" />}
        textButton={text || intl.get('account.connect_with_facebook')}
        onClick={onClick}
      />
    </FormGroup>
  )
}

FacebookButton.propTypes = {
  callback: PropTypes.func,
  fbName: PropTypes.string,
  onClick: PropTypes.func,
}

export default FacebookButton
